<template>
  <div>
    <table
      class="
        table
        table-bordered
        table-hover
        table-striped
        table-center
        table-sm
        table-responsive
      "
    >
      <thead>
        <tr>
          <th v-for="(column, index) in columns" :key="index">{{ column }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="keyValue !== 'data.client_documents'">
          <tr v-for="(item, index) in tableData" :key="index">
            <td v-for="(column, indexColumn) in columns" :key="indexColumn">
              {{ item[column] }}
            </td>
          </tr>
        </template>
        <template v-else>
          hello
          <!-- <tr v-for="(item, index) in tableData" :key="index">
            <td v-for="(column, indexColumn) in columns" :key="indexColumn">
              {{ keyValue }}
              <b-card class="vsa-card-border-gray mb-2">
                {{ column }}
                <template v-for="(element, key) in item[column]">
                  <dl class="row mb-0">
                    <dt class="col-sm-4 fs-900 fw-500 mb-0">
                      {{ fnGetSnakeToTitle(key) }}
                    </dt>
                    <dd class="col-sm-8 fs-900 mb-0">
                      <template>
                        <span v-if="key == 'note'" v-html="element"></span>
                        <span v-else-if="key == 'url'"
                          ><a
                            :href="element"
                            target="_blank"
                            class="text-primary fw-600"
                            >Open document</a
                          ></span
                        >
                        <span v-else-if="key == 'quote_url'"
                          ><a
                            :href="element"
                            target="_blank"
                            class="text-primary fw-600"
                            >Open quote</a
                          ></span
                        >
                        <span v-else>{{ element }}</span>
                      </template>
                    </dd>
                  </dl>
                </template>
              </b-card>
            </td>
          </tr> -->
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
import { fnSnakeToTitle } from '../../services/sharedFn.service'
export default {
  name: 'WDDynamicTable',
  props: ['tableData', 'keyValue'],
  computed: {
    columns() {
      let tableData = this.tableData[0]
      return Object.keys(tableData)
    }
  },
  methods: {
    getColumns() {},
    fnGetSnakeToTitle(str) {
      return fnSnakeToTitle(str)
    }
  }
}
</script>
